import { PATHS } from "@/config/paths";
import { useUser } from "@/hooks/useUser";
import { useNavigate } from "@tanstack/react-router";
import { Avatar } from "@/components/ui/avatar";
import { getInitials } from "@/utilities/getInitials";
import { getSubscriptionStatusText, isSubscriptionExpiringSoon } from "@/utilities/subscription-helpers";

export const SidebarUser = () => {
  const navigate = useNavigate();
  const { user, hasPro, isAuthenticated } = useUser();

  if (!isAuthenticated || !user) {
    return null;
  }

  // Get the active subscription from user data
  const activeSubscription = user?.subscriptions?.[0];
  const subscriptionStatusText = getSubscriptionStatusText(
    hasPro,
    activeSubscription?.cancelAtPeriodEnd,
    activeSubscription?.periodEnd
  );
  
  const isExpiringSoon = activeSubscription?.cancelAtPeriodEnd && activeSubscription?.periodEnd 
    ? isSubscriptionExpiringSoon(activeSubscription.periodEnd)
    : false;

  return (
    <div
      onClick={() => navigate({ to: PATHS.SETTINGS })}
      className="flex items-center gap-3 p-2 rounded-lg hover:bg-sidebar-accent cursor-pointer"
    >
      <Avatar className="h-8 w-8">
        {user.image || user.avatar ? (
          <img
            src={user.image || user.avatar}
            alt={user.name || "User avatar"}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="h-full w-full bg-muted flex items-center justify-center text-sm font-medium">
            {getInitials(user.name || "")}
          </div>
        )}
      </Avatar>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium truncate">{user.name || "User"}</div>
        <div className={`text-xs truncate ${isExpiringSoon ? "text-destructive font-medium" : "text-muted-foreground"}`}>
          {subscriptionStatusText}
        </div>
      </div>
    </div>
  );
};
